import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { CheckCircle, Loader2, Trash2 } from 'lucide-react';
import { API } from './constants';
import { useAuth } from '../../contexts/AuthContext';
import { EcheancesSupprimees } from '../EcheancesSupprimees';

const eur = (v) => (parseFloat(v) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
const dateFr = (d) => (d ? new Date(d).toLocaleDateString('fr-FR') : '-');

export const EcheancesSouscription = ({ doc, getAuthHeader, onDone }) => {
  const { user } = useAuth() || {};
  const [busy, setBusy] = useState(null);
  const [tick, setTick] = useState(0);
  const echeances = doc.echeancier || [];
  const superAdmin = (user?.role || '').toLowerCase() === 'super_admin';
  const base = `${API}/souscriptions/admin/${doc.id}`;
  const corbeille = superAdmin && (
    <EcheancesSupprimees listUrl={`${base}/echeancier-supprimees`} headers={getAuthHeader()} refreshKey={tick}
      restoreUrl={(t) => `${base}/echeancier/restaurer?trace_id=${t.trace_id}`} restoreAllUrl={`${base}/echeancier/restaurer?tout=true`}
      onDone={onDone} testId={`echeances-supprimees-${doc.id}`} />
  );
  if (!echeances.length) return corbeille || null;

  const supprimer = async (e) => {
    if (!window.confirm(`Supprimer l'échéance n°${e.numero} du ${dateFr(e.date)} (${eur(e.montant)}) ?${(e.paye || e.statut === 'paye') ? '\n\nElle est déjà payée : ce paiement sera retiré de l\'historique.' : ''}\n\nLe reçu acquitté sera régénéré.`)) return;
    setBusy(e.numero);
    try {
      const { data } = await axios.delete(`${API}/souscriptions/admin/${doc.id}/echeancier/${e.numero}`, { headers: getAuthHeader() });
      toast.success(data.message);
      setTick((n) => n + 1);
      await onDone?.();
    } catch (err) { toast.error(err.response?.data?.detail || 'Suppression impossible'); }
    finally { setBusy(null); }
  };

  return (
    <div className="mt-3 rounded-lg border border-amber-200 bg-amber-50/40 p-2" data-testid={`echeances-souscription-${doc.id}`}>
      <p className="text-xs font-semibold text-amber-800 mb-1">Échéancier ({echeances.length})</p>
      <div className="space-y-1">
        {echeances.map((e) => {
          const payee = e.paye || e.statut === 'paye';
          return (
            <div key={e.numero} className="flex items-center gap-2 text-xs" data-testid={`echeance-ligne-${doc.id}-${e.numero}`}>
              <span className="font-semibold w-6">#{e.numero}</span>
              <span className="w-20">{dateFr(e.date)}</span>
              <span className="flex-1 font-medium">{eur(e.montant)}</span>
              {payee
                ? <span className="text-emerald-700 inline-flex items-center gap-1"><CheckCircle className="h-3 w-3" /> Payée</span>
                : <span className="text-amber-700">Prévue</span>}
              {superAdmin && (
                <button type="button" onClick={() => supprimer(e)} disabled={busy === e.numero} title="Supprimer cette échéance"
                  className="text-red-600 hover:text-red-800 disabled:opacity-50" data-testid={`supprimer-echeance-${doc.id}-${e.numero}`}>
                  {busy === e.numero ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Trash2 className="h-3.5 w-3.5" />}
                </button>
              )}
            </div>
          );
        })}
      </div>
      {corbeille}
    </div>
  );
};
